export default __webpack_public_path__ + "494d1138664de9abd380b5622d22bdd1.svg";